import React from "react"
import styled from "styled-components"
import { Container, HeroImage } from "./Hero.styles"

export const Hero = ({ data }) => {
	const url = data.primary.hero_image?.url

	return (
		<>
			<Container>
				<HeroImage src={url} />
			</Container>
		</>
	)
}
